<ng-container *transloco="let t">
    <ng-container
        *ngIf="{
            required: required$ | async,
            values: values.$ | async,
        } as data"
    >
        <ng-container *ngIf="ngControl.control; let control">
            <div
                [class]="'bazis-control bazis-control_autocomplete ' + cssClassSizeControl"
                [ngClass]="{
                    'bazis-control--focused': isFocused,
                    'bazis-control--activated': showList,
                    'bazis-control--dirty': ngControl.control.dirty,
                    'bazis-control--empty':
                        emptyValues.indexOf(ngControl.control.value) > -1 ||
                        (multiple && !ngControl.control.value?.length),
                    'bazis-control--invalid': control.invalid,
                    'bazis-control--disabled': isDisabled,
                }"
                clickOutside
                (clickOutside)="hideList()"
            >
                <bazis-label
                    [isMajor]="hasTitleMajor"
                    [isEmptyLabel]="isEmptyLabel"
                    [title]="title || t(titleKey, titleParams)"
                    [required]="data.required"
                >
                    <bazis-interrogation
                        *ngIf="tooltipKey"
                        [slot]="tooltipSettings?.targetSide"
                        iconSize="compact"
                        [tooltipText]="t(tooltipKey, tooltipParams)"
                        [tooltipOffset]="[-8, 4]"
                        [tooltipEventType]="tooltipSettings?.eventType || 'hover'"
                        [tooltipPlacement]="tooltipSettings?.placement || 'top-start'"
                        [icon]="icons.interrogation"
                        [type]="interrogationType"
                    ></bazis-interrogation>
                </bazis-label>

                <div
                    class="bazis-control__field-group"
                    [class.bazis-control__field-group--activated]="showList"
                    [class.bazis-control__field-group--disabled]="isDisabled"
                >
                    <bazis-control-field-start
                        [isClickable]="isLeftIconClickable"
                        [icon]="leftIcon"
                        [tooltipText]="t(tooltipKey, tooltipParams)"
                        [tooltipSettings]="tooltipSettings"
                        (actionClick)="onLeftIconClick($event)"
                    >
                    </bazis-control-field-start>

                    <div class="bazis-control__field">
                        <!-- Прекрасный кастомный селект -->
                        <div
                            class="bazis-select"
                            [class.bazis-select_secondary]="type === 'secondary'"
                            (click)="toggleList()"
                        >
                            <div
                                *ngIf="!showList && !isFocused"
                                class="bazis-select__trigger"
                            >
                                <span>
                                    <ng-container
                                        *ngFor="let value of values.$ | async; let i = index"
                                    >
                                        <ng-container *ngIf="!value">{{
                                            placeholderKey ? t(placeholderKey) : ''
                                        }}</ng-container>
                                        <ng-container *ngIf="staticOptionsEntitiesMap[value]">
                                            <bazis-autocomplete-selected-value
                                                [infiniteListTpl]="infiniteListTpl"
                                                [selectedValueTpl]="selectedValueTpl"
                                                [entity]="staticOptionsEntitiesMap[value]"
                                                [valuesLength]="values._.length"
                                                [index]="i"
                                            ></bazis-autocomplete-selected-value>
                                        </ng-container>
                                        <ng-container
                                            *ngIf="
                                                !staticOptionsEntitiesMap[value] &&
                                                searchSettings.entityType !==
                                                    'organization.organization_info'
                                            "
                                        >
                                            <ng-container
                                                *ngIf="value | entity: entityType | async as entity"
                                            >
                                                <bazis-autocomplete-selected-value
                                                    [infiniteListTpl]="infiniteListTpl"
                                                    [selectedValueTpl]="selectedValueTpl"
                                                    [entity]="entity"
                                                    [valuesLength]="values._.length"
                                                    [index]="i"
                                                ></bazis-autocomplete-selected-value>
                                            </ng-container>
                                        </ng-container>
                                        <ng-container
                                            *ngIf="
                                                !staticOptionsEntitiesMap[value] &&
                                                searchSettings.entityType ===
                                                    'organization.organization_info'
                                            "
                                        >
                                            <ng-container
                                                *ngIf="value | organization | async as entity"
                                            >
                                                <bazis-autocomplete-selected-value
                                                    [infiniteListTpl]="infiniteListTpl"
                                                    [selectedValueTpl]="selectedValueTpl"
                                                    [entity]="entity"
                                                    [valuesLength]="values._.length"
                                                    [index]="i"
                                                ></bazis-autocomplete-selected-value>
                                            </ng-container>
                                        </ng-container>
                                    </ng-container>
                                </span>
                                <div
                                    class="bh-shrink"
                                    *ngIf="values._.length > 1"
                                >
                                    &nbsp;( {{ values._.length }} )
                                </div>
                            </div>
                            <input
                                #searchInput
                                class="bazis-control__field"
                                [formControl]="searchControl"
                                [placeholder]="placeholderKey ? t(placeholderKey) : ''"
                                (focus)="isFocused = true"
                                (blur)="isFocused = false"
                            />
                        </div>
                    </div>

                    <bazis-control-search-end
                        [tooltipText]="t(tooltipKey, tooltipParams)"
                        [tooltipSettings]="tooltipSettings"
                        [hasSearchIcon]="hasSearchIcon"
                        [multiple]="multiple"
                        [isDisabled]="isDisabled"
                        [canEraserShow]="hasEraser"
                        [searchValue]="searchControl.value"
                        [controlValue]="control.value"
                        [iconUp]="iconUp"
                        [iconDown]="iconDown"
                        [showList]="showList"
                        (erased)="onClear()"
                        (toggled)="toggleList()"
                    ></bazis-control-search-end>

                    <bazis-infinite-list-sort-selected
                        class="bazis-list bazis-list_control-dd"
                        [hidden]="!showList"
                        [searchSettings]="searchSettings"
                        [emptyValue]="emptyValueEntity"
                        [search$]="searchControl.valueChanges"
                        [staticOptionsEntities]="staticOptionsEntities"
                        [selectedList$]="selectedList$"
                        [selectedMap]="valuesMap"
                        [isMultiple]="multiple"
                        [hasApplyBtn]="mqSrv.inIntervalBreakpoint('xs', 'lg')"
                        (cleared)="onClear()"
                        (applied)="list.applyAll(); hideList()"
                    >
                        <ng-template let-item="item">
                            <bazis-multiple-selection-item
                                [item]="item"
                                [infiniteListTpl]="infiniteListTpl"
                                [fieldForId]="searchSettings.fieldForId"
                                [multiple]="multiple"
                                [valuesMap]="valuesMap"
                                (toggled)="
                                    toggleSelectedValue(
                                        searchSettings.fieldForId &&
                                            item.$snapshot[searchSettings.fieldForId]
                                            ? item.$snapshot[searchSettings.fieldForId]
                                            : item,
                                        $event
                                    )
                                "
                            ></bazis-multiple-selection-item>
                        </ng-template>
                    </bazis-infinite-list-sort-selected>
                </div>

                <div class="bazis-control__error">
                    <bazis-form-error [formControl]="ngControl.control"></bazis-form-error>
                    <ng-content select="error"></ng-content>
                </div>

                <div
                    *ngIf="noteKey"
                    class="bazis-control__note"
                >
                    {{ t(noteKey, noteParams) }}
                </div>
                <ng-content select="note"></ng-content>
            </div>
        </ng-container>
    </ng-container>
</ng-container>
